import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  basicTitle = environment.title;
  basicTitleHidden = environment.titleHidden;
  numeroNotificaciones: number = 0;
  hidden: boolean = false;
  title$: Subject<string> = new Subject();
  blinkInterval: any = null;

  constructor(private translateService: TranslateService) {
   }

  public setTitle$(title: string) {
    if(title == undefined || title == null)
      title = this.basicTitle;
    else if (!title.startsWith("(") && this.numeroNotificaciones > 0)
      title = "(" + this.numeroNotificaciones + ") " + title;
    
    // Si hay notificaciones y la página está oculta, inicia el parpadeo
    if (this.numeroNotificaciones > 0 && this.hidden) {
      // Solo iniciamos el intervalo si aún no está activo
      if (this.blinkInterval == null) {
        let i = 0;
        this.blinkInterval = setInterval(() => {
          // Si en medio del parpadeo la pestaña se vuelve visible, detenemos el parpadeo
          if (!document.hidden) {
            clearInterval(this.blinkInterval);
            this.blinkInterval = null;
            this.title$.next(title);
            return;
          }
          // Alterna entre el título con notificaciones y el título básico
          if (i % 2 === 0) {
            this.title$.next(title);
          } else {
            this.title$.next("(" + this.numeroNotificaciones + ") " + this.basicTitle);
          }
          i++;
        }, 500);
      }
    } else {
      // Si no hay notificaciones o la página está visible, detenemos el parpadeo si está activo
      if (this.blinkInterval) {
        clearInterval(this.blinkInterval);
        this.blinkInterval = null;
      }
      this.title$.next(title);
    }
  }

  getTitle$(): Observable<string> {
    return this.title$.asObservable();
  }

  actualizarTitulo(numero: number){
    this.numeroNotificaciones = numero;
    var title = "";
    if(this.hidden && this.numeroNotificaciones > 0)
      title = this.translateService.instant(this.basicTitleHidden);
    else
      title = this.basicTitle;
    if(numero > 0)
      this.setTitle$("(" + this.numeroNotificaciones + ") " + title);
    else
      this.setTitle$(title);
  }
}
